import Form from "@/components/common/form/form";
import Model from "@/components/common/model.component";
import { useRouter } from "next/router";
import MachinaryForm from "./machinaryForm";
import { authServices } from "services/auth.services";
import { MachinService } from "services/add-machin";
import { useSwrGet } from "@/utils/use-swr-get";
import { useDispatch, useSelector } from "react-redux";
import { setValveData } from "@/redux/actions/valves/valveData";
import AddLocation from "./locationModal";
import { useTranslation } from "react-i18next";
import PageTitle from "components/common/page-title.component";
import { useState } from "react";

type Reducer = {
  valveDataReducer?: any;
};
export default function AddMachinery(props) {
  const { showModal, setShowModal } = props;
  const [showLocationModal, setLocationModal] = useState(false);
  const [icon, setIcon] = useState("MCH-");
  const { t } = useTranslation();

  const router = useRouter();
  const dispatch = useDispatch();

  const {
    data: farmData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(
    `/farm/all`,
    process.env.NEXT_PUBLIC_BASE_URL +
      `farms/details/${authServices.userValue.org_id}/`
  );

  const onSubmit = async (data, e) => {
    let res = await MachinService.addMachin({
      ...data,
      machinery_code: "MCH-" + data.machinery_code,
      entity_type_id: props.getEntityTypeId,

      farm_id: Number(data.farm_id),
      object_id: Number(data.object_id) || null,
      supplier_id: Number(data.supplier_id),
      asset_ref_no: Number(data.asset_ref_no),
      content_type:
        data.object_id === null
          ? null
          : farmData
              ?.filter((item) => item.farm_id == data.farm_id)
              ?.map?.((item) =>
                item.farm_type === "tree"
                  ? authServices.userValue.content_types
                      ?.filter?.((item) => item.model == "treefieldinfo")
                      ?.find?.((item) => item.id)?.id
                  : authServices.userValue.content_types
                      ?.filter?.((item) => item.model == "pivotfieldinfo")
                      ?.find?.((item) => item.id)?.id
              )[0],
    });
    if (res) {
      dispatch(
        setValveData({
          id: res.data.id,
          entity_type_id: res.data.entity_type_id,
        })
      );
      setLocationModal(true);
    }
  };
  return (
    <>
      <Model
        width="w-130"
        show={showModal}
        onClose={(e) => {
          setShowModal(false);
        }}
      >
        <PageTitle title={t("AddMachinery")} titletextSize="text-xl" />
        <Form
          defaultValues={{
            machinery_category: props.defaultValue?.replaceAll("-", "_"),
          }}
          onSubmit={onSubmit}
        >
          <MachinaryForm reset passProps icon={icon} />
        </Form>
      </Model>
      <AddLocation
        setRefresh={props.setRefresh}
        showModal={showLocationModal}
        setShowModal={setLocationModal}
        closeMainModal={setShowModal}
      />
    </>
  );
}
